export var createMuiBackdropOverrides = function (_a) {
    var tokens = _a.tokens;
    return {
        styleOverrides: {
            root: {
                backgroundColor: tokens.color_bg_backdrop,
            },
            invisible: {
                backgroundColor: 'transparent',
            },
        },
    };
};
